import { render } from "./restaurantSpace.vue?vue&type=template&id=04c83566&scoped=true"
import script from "./restaurantSpace.vue?vue&type=script&lang=js"
export * from "./restaurantSpace.vue?vue&type=script&lang=js"

import "./restaurantSpace.vue?vue&type=style&index=0&id=04c83566&scoped=true&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04c83566"]])

export default __exports__